import { useContext } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomIcon,
  ShowConfirm,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";

const Body = (data: any) => {
  const { resultDriver, setSelectedDriver, setShowModal } = useContext(
    Context.DriverScreen
  );

  const drivers = resultDriver?.data?.result?.docs;

  const onUpdate = (driver: ICreateAndUpdateDriver) => {
    setSelectedDriver!(driver);
    setShowModal!("UPDATE");
  };
  const onDelete = (driver: ICreateAndUpdateDriver) => {
    setSelectedDriver!(driver);
    setShowModal!("DELETE");
  };

  if (drivers?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="driver-table-body-container">
      {drivers?.map((driver: any, index: number) => {
        return (
          <tr key={`driver-${index}`}>
            <td className="pointer">
              <UserInformation
                avatar={driver?.avatar}
                name={driver?.firstName}
                lastName={driver?.lastName}
                phoneNumber={driver?.phoneNumber}
              />
            </td>
            <td className="pointer">
              <UserInformation
                name={driver?.company?.name}
                phoneNumber={driver?.company?.phoneNumber}
                hideAvatar
              />
            </td>
            {/* <td>
              <PlateNumberr
                defaultValue={driver?.driverInformation?.plateNumber}
                size="xs"
                isEditable={false}
              />
            </td> */}
            <td>{driver?.nationalCode}</td>
            {/* Status */}
            <td className="pointer">
              {/* <CustomBadges
                isDisable
                title={
                  driver?.schoolDriverInformation?.approved?.isApproved === true
                    ? "راننده تایید شده"
                    : "راننده تایید نشده"
                }
                type={
                  driver?.schoolDriverInformation?.approved?.isApproved === true
                    ? "success"
                    : "danger"
                }
              /> */}
              <ShowConfirm
                icon="fa-solid fa-car"
                isConfirm={
                  driver?.schoolDriverInformation?.approved?.isApproved
                }
                title="راننده تایید شده"
              />
            </td>

            {/* <td>
              <div className="documents-approve-column">
                <CustomBadges
                  type={
                    !driver?.schoolDriverInformation?.documents
                      ? "warning"
                      : !driver?.schoolDriverInformation?.documents?.approve
                      ? "danger"
                      : "success"
                  }
                  title={
                    !driver?.schoolDriverInformation?.documents
                      ? "مدارک بارگذاری نشده"
                      : !driver?.schoolDriverInformation?.documents?.approve ===
                        true
                      ? "مدارک تأیید نشده"
                      : "مدارک تأیید شده"
                  }
                />

                <CustomIcon
                  icon="fas fa-file-check"
                  hoverTitle="تایید مدارک"
                  // onClick={() => onDocumentsApprove(driver)}
                />
              </div>
            </td> */}
            {/* actions */}
            <td>
              <div className="table-actions-buttons">
                {/* <CustomIcon
                  icon="fas fa-credit-card"
                  hoverTitle="پرداخت شهریه سرویس های راننده"
                  // onClick={() => onPayServicesPrice(driver)}
                /> */}
                {/* Approve Icon */}
                {/* <CustomIcon
                    icon="fas fa-check"
                    hoverTitle="تایید کردن"
                    // onClick={() => onApprove(driver)}
                  /> */}
                {/* Edit Icon */}
                <CustomIcon
                  icon="fas fa-pen"
                  hoverTitle="ویرایش"
                  onClick={() => onUpdate(driver)}
                />
                <CustomIcon
                  icon="fas fa-trash"
                  hoverTitle="حذف"
                  onClick={() => onDelete(driver)}
                />
                {/* <CustomIcon
                  icon="fas fa-list"
                  hoverTitle="مشاهده همه سرویس"
                  // onClick={() => onShowAllService(driver)}
                /> */}
                {/* <CustomIcon
                  icon="fas fa-tag"
                  hoverTitle="دریافت برچسب راننده"
                  // onClick={() => onLabelModalHandler(driver)}
                /> */}
                {/* <CustomIcon
                  icon="fas fa-ban"
                  hoverTitle="مسدود کردن"
                  // onClick={() => onBlock(driver)}
                /> */}

                {/* <CustomIcon
                    icon="fas fa-shield-xmark"
                    hoverTitle="دلیل مسدود شدن"
                    // onClick={() => onViewBlockInfo(driver)}
                  />{" "} */}
                {/* <CustomIcon
                    icon="fas fa-shield-check"
                    hoverTitle="رفع مسدودی"
                    // onClick={() => onUnBlockInfo(driver)}
                  /> */}

                {/* Delete Modal */}
                {/* <CustomIcon icon="fas fa-trash" hoverTitle="حذف" onClick={() => onDelete(driver)} /> */}
                {/* Block Icon */}
                {/* <CustomIcon icon="fas fa-ban" hoverTitle="مسدود کردن" onClick={() => console.log("Block")} /> */}
                {/* Block-Reason Icon */}
                {/* {driver.blocks.length > 0 && (
                  <CustomIcon icon="fas fa-shield-xmark" hoverTitle="دلیل مسدودی" onClick={() => console.log("Reason")} />
                )} */}
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
